import React from 'react';
import { Box, Grid } from '@material-ui/core';
import {Backdrop} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';


const CustomizedDialogs = ((props) => { 
  
  
  return (<>
      <Backdrop
					sx={{ flexDirection: 'column', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={true}
				>
					<Box>
						<Grid container >
							<Grid item md={12}>
								<CircularProgress color="inherit" />
							</Grid>
						</Grid>
					</Box>
					<Box>
						<Grid container >
							<Grid item md={12}>
                  {props.message}
							</Grid>
						</Grid>
					</Box>
			</Backdrop>
  </>);

});

export default CustomizedDialogs;